const state = () => ({
  painelAberto: true,
});

const mutations = {
  TOGGLE_PAINEL(state) {
    state.painelAberto = !state.painelAberto;
  },
  FECHAR_PAINEL(state) {
    state.painelAberto = false;
  },
};

const actions = {
  togglePainel({ commit }) {
    commit("TOGGLE_PAINEL");
  },
  fecharPainel({ commit }) {
    commit("FECHAR_PAINEL");
  },
};

export const suporteAgente = { namespaced: true, state, mutations, actions };
